<template>
    <page>
        <module title="订单商品评价详情">
            <div v-if="evaluateInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="订单号">{{evaluateInfo.order_number}}</c-detail-item>

                    <c-detail-item label="评价时间">{{evaluateInfo.pj_date}}</c-detail-item>

                    <c-detail-item label="评价用户">{{evaluateInfo.nick_name}}</c-detail-item>

                    <c-detail-item label="用户手机号">{{evaluateInfo.user_manage_mobilephone}}</c-detail-item>

                    <c-detail-item label="评分">{{evaluateInfo.score}}</c-detail-item>

                    <c-detail-item label="商品信息">
                        <template v-slot="{data}">
                            <product-info v-if="evaluateInfo.product_itemnumber" :image="evaluateInfo.product_img_url" :name="evaluateInfo.product_itemnumber + ' - '+evaluateInfo.product_name"></product-info>
                            <product-info v-else :image="evaluateInfo.product_img_url" :name="evaluateInfo.product_name"></product-info>
                        </template>
                    </c-detail-item>

                    <c-detail-item label="商品规格">{{evaluateInfo.product_sku_spec}}</c-detail-item>

                    <c-detail-item label="SKU编码">{{evaluateInfo.product_sku_code}}</c-detail-item>
                    <c-detail-item label="是否置顶">
                        <template v-slot="{data}">
                            <span v-if="evaluateInfo.is_top == 1" style="color:red">置顶</span>
                            <span v-else>-</span>
                        </template>
                    </c-detail-item>
                    <c-detail-item label="置顶时间">
                        <template v-slot="{data}">
                            <span v-if="evaluateInfo.is_top && evaluateInfo.top_date">{{evaluateInfo.top_date}}</span>
                            <span v-else>--</span>
                        </template>
                    </c-detail-item>

                    <c-detail-item label="评价内容" full>{{evaluateInfo.evaluate_comment}}</c-detail-item>

                </c-detail>

                <c-detail title="评价图片/视频信息">
                    <c-detail-item  full>
                        <c-table v-model="evaluateMediaList" height="auto" border>
                            <c-table-column
                                    label="类型"
                                    name="type"
                                    width="100"
                            >
                                <template v-slot="{data}">
                                    {{typeText[data.type]}}
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="文件"
                                    name="file_url"
                                    width="100"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.type==1"> <c-image :src="data.file_url" preview size="60" style="margin-right: 10px;"></c-image></span>
                                    <span v-if="data.type==2">
                                        <c-image v-if="data.file_url" :src="data.file_url" preview size="60"></c-image>
                                    </span>
                                </template>
                            </c-table-column>

                        </c-table>
                    </c-detail-item>
                </c-detail>

                <c-detail title="评价标签信息">
                    <c-detail-item  label="标签信息" full>
                        {{evaluateInfo.tag_name}}
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'order_evaluate_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                evaluateInfo: '',
                evaluateMediaList: [],
                typeType: [{
                    name: '图片',
                    value: 1
                },{
                    name: '视频',
                    value: 2
                }
                ]
            }
        },

        computed: {
            ...mapState(['dict']),

            typeText() {
                var state = {};
                this.typeType.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        watch: {
            id() {
                this.getEvaluateDetail();
            }
        },

        mounted() {
            this.getEvaluateDetail();
        },

        methods: {
            getEvaluateDetail() {
                this.request({
                    url: '/orderEvaluate/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.evaluateInfo = data;
                        this.evaluateMediaList = data.evaluate_media_list;
                    }
                });
            }
        }
    }
</script>
